import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "m13.5 13.7-6.8 6.8c-.9.9-2.3.9-3.2 0s-.9-2.3 0-3.2l6.8-6.8c-.8-2-.3-4.3 1.3-5.9 1.7-1.7 4.2-2 6.2-1.2.1 0 .1.1 0 .2l-3.6 3.6 2.6 2.6 3.7-3.6h.2c1 2 .5 4.5-1.2 6.2-1.7 1.6-4 2-6 1.3",
      stroke: "black",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }